import { Chip, styled } from '../../../../../base-components';

export const StyledChip = styled(Chip)(({ theme }) => {
    return {
        border: `1px dashed ${theme.palette.secondary.main}`,
        borderRadius: '37px',
        height: '48px',
        color: theme.palette.secondary.main,
        '& .MuiChip-label': {
            color: theme.palette.secondary.main,
        },
        backgroundColor: 'transparent',
    };
});

export const RangeBlockChipWrapper = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minHeight: '32px',
    width: '100%',
}));

export const BooleanFilterWrapper = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    minHeight: '32px',
    width: '100%',
}));
